module.exports = __webpack_public_path__ + "static/media/filmting-svg-logo-400x400.bca38c21.svg";